import React from 'react'

export const useMeQueryKey = () => React.useMemo(() => ['UseMeQuery_Main'], [])
